import Coms from '@/communications'
import bus from '@/plugins/bus'

export default {
  CLEAR (context) {
    context.commit('clearViews')
    context.commit('clearHistory')
    context.commit('customer/clearCustomerData')
    context.commit('project/clear')
  },
  async getProject ({ commit }, projectId) {
    try {
      console.log('getting project')
      const data = await Coms.project.getProject(projectId)
      commit('project/setProjectData', data)
    } catch (err) {
      console.error(err)
      bus.emit('notification', err, {
        color: 'error',
        dark: true
      })
      throw err
    }
  },
  async getViews ({ commit }, projectId) {
    try {
      const data = await Coms.view.getProjectViewsForNavigation(projectId)
      commit('setViews', data)
    } catch (err) {
      console.error(err)
      bus.emit('notification', err, {
        color: 'error',
        dark: true
      })
      throw err
    }
  }
}
